var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\"><div flex=\"flex\"><div layout=\"column\" class=\"itemCardHeader\"><h4>General Notes</h4></div><div style=\"margin: 5px\" class=\"form-group\"><textarea name=\"notes\" placeholder=\"Add notes here\" rows=\"10\" ng-model=\"vm.docSvc.doc.notes\" class=\"form-control\"></textarea></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/venues/tabs/tab-notes.jade
// module id = 287
// module chunks = 0